<dx-pie-chart
    *ngIf="!!plattedLotChartData"
    [palette]="plattedLotChartPalette || palette"
    [paletteExtensionMode]="paletteMode"
    [diameter]="diameter"
    [dataSource]="plattedLotChartData"
    [sizeGroup]="pieGroup"
    class="cc-white-background"
>
    <dxo-title [text]="plattedLotChartTitle">
        <dxo-font [size]="14" [weight]="600"></dxo-font>
        <dxo-margin [top]="5" [bottom]="0" [left]="0" [right]="0"></dxo-margin>
    </dxo-title>
    <dxo-legend
        horizontalAlignment="right"
        verticalAlignment="top"
        orientation="vertical"
        [customizeText]="customizeText"
        [columnItemSpacing]="5"
        [rowItemSpacing]="1"
    >
        <dxo-font [size]="fontSize"></dxo-font>
    </dxo-legend>
    <dxo-size [width]="width" [height]="height"></dxo-size>
    <dxi-series argumentField="label" valueField="percentage"></dxi-series>
    <dxo-export [enabled]="!widgetMode" [fileName]="exportFileName()"></dxo-export>
</dx-pie-chart>
